import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { getStore } from "./redux/store";

// React Components
import Stories from "./components/Stories";
import Loader from "./components/ui/Loader";

const element = document.getElementById("stories-app");

if (element) {
  const root = ReactDOM.createRoot(element);
  const nodeAliasPath = element.getAttribute("node");
  const lang = element.getAttribute("language");
  const isKidsApp = document.body.dataset.app === "kids";
  const store = getStore({
    nodeAliasPath,
    lang,
    isKidsApp,
  });

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <Loader />
        <Stories />
      </Provider>
    </React.StrictMode>
  );
}
